import { createRequiredContext } from '@kamernet/utilities/RequiredContext';
import { IntlObject } from './types';

export const IntlContext = createRequiredContext<IntlObject>('IntlContext');
